export class PaymentType {
    static CREDIT_CARD = 1;
    static CASH = 2;
    static TWINT = 3;
    static INVOICE = 4;
    static QUOTATION = 5;   // Devis avec le presta
    static LEASING_INVOICE = 6;
}

Object.freeze(PaymentType);